module.exports = __webpack_public_path__ + "static/media/jenkins.d180cf32.svg";